import React from "react";
import { Typography, Divider } from "antd";
import "./Agreements.css";

// List of PDF documents
const documents = [
  {
    title: "Tedarikçi İş Ortağı Temsilcisi Aydınlatma Metni",
    path: "/documents/Tedarikçi İş Ortağı Temsilcisi Aydınlatma Metni.pdf",
    description:
      "Tedarikçi İş Ortağı temsilcileri için kişisel verilerin işlenmesine ilişkin aydınlatma metni.",
  },
  {
    title: "Üçüncü Şahıs Aydınlatma Metni",
    path: "/documents/Üçüncü Şahıs Aydınlatma Metni.pdf",
    description:
      "Üçüncü şahıslar için kişisel verilerin işlenmesine ilişkin aydınlatma metni.",
  },
  {
    title: "Ziyaretçi Aydınlatma Metni",
    path: "/documents/Ziyaretçi Aydınlatma Metni.pdf",
    description:
      "Ziyaretçiler için kişisel verilerin işlenmesine ilişkin aydınlatma metni.",
  },
  {
    title: "Aday Üyelik Aydınlatma Metni",
    path: "/documents/Aday Üyelik Aydınlatma Metni.pdf",
    description:
      "Aday üyeler için kişisel verilerin işlenmesine ilişkin aydınlatma metni.",
  },
  {
    title: "Çalışan Aydınlatma Metni",
    path: "/documents/Çalışan Aydınlatma Metni.pdf",
    description:
      "Çalışanlar için kişisel verilerin işlenmesine ilişkin aydınlatma metni.",
  },
  {
    title: "İşveren Müşteri Temsilcisi Aydınlatma Metni",
    path: "/documents/İşveren Müşteri Temsilcisi Aydınlatma Metni.pdf",
    description:
      "İşveren müşteri temsilcileri için kişisel verilerin işlenmesine ilişkin aydınlatma metni.",
  },
];

const Agreements = () => {
  return (
    <div className="agreements-container">
      <Typography.Title level={2} className="section-title">
        Sözleşmeler ve Aydınlatma Metinleri
      </Typography.Title>

      <Divider />

      {documents.map((document, index) => (
        <div key={index} className="pdf-container">
          <Typography.Title level={4} className="pdf-title">
            {document.title}
          </Typography.Title>
          <Typography.Paragraph className="pdf-description">
            {document.description}
          </Typography.Paragraph>
          <iframe
            src={document.path}
            title={document.title}
            className="pdf-iframe"
            width="100%"
            height="800px"
            frameBorder="0"
          />
          {index < documents.length - 1 && <Divider />}
        </div>
      ))}
    </div>
  );
};

export default Agreements;
